// Navigation Animation
export const navVariants = {
    hidden: {
        opacity: 0
    },
    show: {
        opacity: 1,
        transition: {
            duration: 0.4,
            ease: "easeOut"
        }
    }
};

// Container
export const fixedContainer = (content, delay) => ({
    hidden: {},
    show: {
        transition: {
            content,
            delay
        }
    }
});

// Text Animation
export const textVariants = (direction, delay) => ({
    hidden: {
        opacity: 0
    },
    show: {
        opacity: 1,
        transition: {
            duration: 0.5,
            delay,
            ease: "easeOut"
        }
    }
});

// Form Animation
export const formVariants = (delay) => ({
    hidden: {
        opacity: 0
    },
    show: {
        opacity: 1,
        transition: {
            duration: 0.5,
            delay,
            ease: "easeOut"
        }
    }
});

// Fade Animation
export const fadeIn = {
    hidden: {
        opacity: 0
    },
    show: {
        opacity: 1,
        transition: {
            duration: 0.5,
            ease: "easeOut"
        }
    }
};

// Fixed Button Animation
export const fixedBtn = {
    hidden: {
        opacity: 0
    },
    show: {
        opacity: 1,
        transition: {
            duration: 0.3,
            ease: "easeOut"
        }
    }
};